<template lang="pug">
  v-container
    v-layout.text-xs-center(row)
      v-flex(xs12)
        div.py-1.title(v-if="res.status==='success'") {{description}} 
          div.py-1.subheading.text--green Your order has been completed successfully
          div.py-2.subheading Please ensure you present the QR code and your ID when collecting. 
          div.py-1.subheading Go to the "my orders" to download your QR code.
          v-btn.my-3( to="/my-orders" color="primary") Go to My Orders
        div.title(v-else) {{description}}
          div.subheading There was a problem completing this order 
</template>
<script>
export default {
  data:()=>({
    res:{}
  }),
  computed:{
    description(){
      if (Object.keys(this.res).length > 0){
        return this.res.reasonDescription.split("%20").join(" ")
      }else{
        return ""
      }
    }
  },
  mounted(){
    let res = {}
    window.location.search.substring(1).split('&').forEach(el=>{
      let arr = el.split("=")
      res[arr[0]] = arr[1]
    })
    this.res = res
    this.$store.dispatch('verifyTransaction',res)
    this.$store.dispatch('clearCart')
  }
}
</script>

